/** Org members are org-scoped (`GET /orgs/{org}/members`). */
export const orgMembersKeys = {
  list: (organizationId: string) =>
    ["resources", organizationId, "org-members", "list"] as const,
  page: ({
    organizationId,
    limit,
    offset,
  }: {
    organizationId: string;
    limit: number;
    offset: number;
  }) => [...orgMembersKeys.list(organizationId), { limit, offset }] as const,
};

/**
 * Placeholder for a members page: the previous page, but only while it belongs to
 * the same org. Rows from another org must never stand in, because their row
 * actions would run against the org now in the address.
 */
export const previousPageOfSameOrg =
  (organizationId: string) =>
  <T>(
    previous: T | undefined,
    previousQuery?: { queryKey: readonly unknown[] }
  ): T | undefined =>
    previousQuery?.queryKey[1] === organizationId ? previous : undefined;
